
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M400.388 175.787c-1.707-3.413-4.267-5.12-7.68-5.12H292.015L391.855 12.8c1.707-2.56 1.707-5.973 0-8.533S387.588 0 384.175 0H247.642c-3.413 0-5.973 1.707-7.68 4.267l-128 256c-1.707 2.56-1.707 5.973 0 8.533 1.707 2.56 5.12 4.267 7.68 4.267h87.893l-95.573 227.84c-1.707 3.413 0 7.68 3.413 10.24.853.853 2.56.853 4.267.853 2.56 0 5.12-.853 6.827-2.56l273.067-324.267c1.706-2.56 2.559-5.973.852-9.386zm-250.88 279.04l78.507-187.733c.853-2.56.853-5.12-.853-7.68-1.707-1.707-4.267-3.413-6.827-3.413h-87.04L252.762 17.067h116.053L268.122 174.933c-1.707 2.56-1.707 5.973 0 8.533s4.267 4.267 7.68 4.267h98.987L149.508 454.827z"}})])
          )
        }
      }
    